import React, { useState, useEffect } from 'react';

const ThinkingIndicator = () => {
  const [text, setText] = useState("noodling");
  const words = ["noodling", "thinking", "dreaming", "working", "architecting", "planning", "structuring"];

  useEffect(() => {
    const interval = setInterval(() => {
      setText(words[Math.floor(Math.random() * words.length)]);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center gap-3 py-2 animate-in fade-in duration-500">
      <div className="flex gap-1">
        {[0, 1, 2, 3, 4].map((i) => (
          <div 
            key={i} 
            className="h-1.5 w-1.5 rounded-full bg-sonas-dim/40 animate-pulse" 
            style={{ animationDelay: `${i * 0.15}s` }}
          />
        ))}
      </div>
      <span className="text-xs font-medium text-sonas-muted lowercase tracking-tight">
        {text}...
      </span>
    </div>
  );
};

export default ThinkingIndicator;